var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"value":_vm.getLotFilters,"items":_vm.getAllLots,"item-text":"name","item-value":"url","label":"Filter by Lot","multiple":"","clearable":""},on:{"input":_vm.setLotFilters}})}
var staticRenderFns = []

export { render, staticRenderFns }